import { render, staticRenderFns } from "./EcommerceDealProductTable.vue?vue&type=template&id=5be8a3e5&scoped=true&"
import script from "./EcommerceDealProductTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceDealProductTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceDealProductTable.vue?vue&type=style&index=0&id=5be8a3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8a3e5",
  null
  
)

export default component.exports